// utils/constants.ts

// ========================================
// ADRL DATA MODEL CONSTANTS
// ========================================
// These define the contract with the backend API

// Total credits required for graduation
export const TOTAL_CREDITS_REQUIRED = 120;

// Course status values from backend
export const COURSE_STATUS_COMPLETED = 'completed';
export const COURSE_STATUS_IN_PROGRESS = 'in_progress';
export const COURSE_STATUS_PLANNED = 'planned';
export const COURSE_STATUS_AVAILABLE = 'available';

export const COURSE_STATUSES = [
  COURSE_STATUS_COMPLETED,
  COURSE_STATUS_IN_PROGRESS,
  COURSE_STATUS_PLANNED,
  COURSE_STATUS_AVAILABLE
];

// ========================================
// API CONSTANTS
// ========================================
// API configuration and timeouts

export const API_URL = (window as any).REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_TIMEOUT_DEFAULT = 30000; // 30 seconds (backend can be slow)
export const API_RETRY_ATTEMPTS = 3;
export const API_RETRY_DELAY = 1000; // 1 second

// ========================================
// UI EXPANSION STATE CONSTANTS
// ========================================
// Keys for tracking expanded/collapsed state in degree audit hierarchy

export const EXPANSION_KEY_SEPARATOR = '-';
export const EXPANSION_KEY_MAJOR_PREFIX = 'major';
export const EXPANSION_KEY_MINOR_PREFIX = 'minor';
export const EXPANSION_KEY_CITATION_PREFIX = 'citation';
export const EXPANSION_KEY_REQ_PREFIX = 'req';
